import React from 'react';
import Icon from './Icon';

const MergeIcon = (props) => (
    <Icon {...props} stroke="none" viewBox="0 0 32 32">
        <path d="M25,4v4.101c0,2.137-0.832,4.146-2.343,5.657l-3.9,3.899c-0.477,0.477-0.858,1.023-1.146,1.612 c-0.232-0.764-0.573-1.49-1.003-2.168c0.225-0.299,0.465-0.589,0.734-0.858l3.9-3.899C22.376,11.21,23,9.703,23,8.101V4H25z M17,25.586v-3.687c0-2.137-0.832-4.146-2.343-5.657l-3.9-3.899C9.624,11.21,9,9.703,9,8.101V4H7v4.101 c0,2.137,0.832,4.146,2.343,5.657l3.9,3.899C14.376,18.79,15,20.297,15,21.899v3.687l-2.293-2.293l-1.414,1.414L16,29.414 l4.707-4.707l-1.414-1.414L17,25.586z" fill="currentColor" />
    </Icon>
);

export default MergeIcon;